import * as actionTypes from './actionTypes';
import axios from '../../config/axios';
import { modifyAuthError } from '../../utils/utils';
import sha256 from 'js-sha256';

const authSuccess = data => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        payload: data
    };
};

const authFailed = error => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const getAuthToken = ({ username, password, remember }) => {
    return dispatch => {
            const authData = { password: sha256(password), username };
        const url = '/customers/login/';
        axios.post(url, authData).then(response => {
                if (remember) {
                    localStorage.setItem('foodna_portal_token', response.data.auth_token);
                    localStorage.setItem('foodna_portal_username', response.data.username);
                    localStorage.setItem('foodna_portal_pk', response.data.pk);
                    localStorage.setItem('foodna_restaurant_id', response.data.restaurant_id);
                }
                dispatch(authSuccess(response.data));
            }).catch(e => {
                const error = modifyAuthError(e);
                dispatch( authFailed(error) );
            });
    };
};


export const signOut = () => {
    localStorage.removeItem('foodna_portal_token');
    localStorage.removeItem('foodna_portal_username');
    localStorage.removeItem('foodna_portal_pk');
    localStorage.removeItem('foodna_restaurant_id');
    return {
        type: actionTypes.AUTH_SIGNOUT
    };
};


export const setAuthRedirectPath = path => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        payload: path
    };
};

export const authCheckState = () => {
    return dispatch => {
        const auth_token = localStorage.getItem('foodna_portal_token');
        if (!auth_token) {
            dispatch(signOut());
        } else {
            const name = localStorage.getItem('foodna_portal_username');
            const pk = localStorage.getItem('foodna_portal_pk');
            const restaurant_id = localStorage.getItem('foodna_restaurant_id');
            dispatch(authSuccess({auth_token, name, pk, restaurant_id }));
        }
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/auth.js